import { render, staticRenderFns } from "./jy-outboundScanDetail.vue?vue&type=template&id=33a1efe8&scoped=true&"
import script from "./jy-outboundScanDetail.vue?vue&type=script&lang=js&"
export * from "./jy-outboundScanDetail.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundScanDetail.vue?vue&type=style&index=0&id=33a1efe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1efe8",
  null
  
)

export default component.exports